import React from 'react';
import { lang,getCurrentLang } from '@umu/ukit-lang';
import { IProfileInfo } from '@umu/umu-types';
import { getProfileIndexUrl as getIndexUrl } from '@umu/umu-util';
import { components } from 'common';
const { If, PreImg } = components;
import { QrGenerator } from '../../../qrCode';



import './rowCard.scss';

import logo from 'common/src/images/logo-white.png';
import defaultAvatar from '../../../../images/defaultAvatar.png';

interface IProps {
    isEnterprise: boolean;
    profileInfo: IProfileInfo;
}

const currentLang  = getCurrentLang().toUpperCase();

export const RowCard = ({ profileInfo, isEnterprise }: IProps) => {
    const shareUrl = getIndexUrl(profileInfo.profile_id);
    const textClassName = "img-text" + (currentLang === 'JP' ? ' jp' : '');


    const renderText = ()=>{
        if(currentLang === "JP"){
            return <><div className={textClassName}>スキャンして</div><div className={textClassName}>コメントしてください</div></>
        }
        return  <div className={textClassName}>{lang('扫码给我留言')}</div>
    }

    return (
        <div className="row-card profile-share-card-row-card">
            <div className="card-body">
                <div className="avatar">
                    <PreImg>
                        <img src={profileInfo.avatar || defaultAvatar} />
                    </PreImg>
                    <div className={`umu-text-clamp clamp-1 ${textClassName}`}>{profileInfo.user_name}</div>
                </div>
                <div className="share-qr-code">
                    <QrGenerator url={shareUrl} />
                    {renderText()}
                </div>
            </div>
            <If condition={!isEnterprise}>
                <div className="card-footer">
                    <PreImg>
                        <img src={logo} />
                    </PreImg>
                </div>
            </If>
        </div>
    );
};
